import { QUERY_PARAMETERS } from "common/constants"
import moment from "moment"

export const PERSONALIZADO_OPTION = (t: $TSMigrationFixMe) =>
  `${t("filtros.fecha.personalizedLabel")}`

export const LAST_ACTIVITY_OPTIONS = (t: $TSMigrationFixMe) => [
  {
    label: `${t("filtros.fecha.todayLabel")}`,
    value: {
      status: moment().format(moment.HTML5_FMT.DATE),
      parent: QUERY_PARAMETERS.DesdeFechaActividad,
    },
    id: 11,
  },
  {
    label: `${t("filtros.fecha.lastSevenLabel")}`,
    value: {
      status: moment().subtract(6, "days").format(moment.HTML5_FMT.DATE),
      parent: QUERY_PARAMETERS.DesdeFechaActividad,
    },
    id: 12,
  },
  {
    label: `${t("filtros.fecha.lastThirtyLabel")}`,
    value: {
      status: moment().subtract(30, "days").format(moment.HTML5_FMT.DATE),
      parent: QUERY_PARAMETERS.DesdeFechaActividad,
    },
    id: 13,
  },
  {
    label: `${t("filtros.fecha.lastSixtyLabel")}`,
    value: {
      status: moment().subtract(60, "days").format(moment.HTML5_FMT.DATE),
      parent: QUERY_PARAMETERS.DesdeFechaActividad,
    },
    id: 14,
  },
]

export const DATE_YYYY_MM_DD = "YYYY-MM-DD"
export const DATE_DD_MM_YYYY = "DD/MM/YYYY"

export const getFechasFilter = (array: $TSMigrationFixMe) => {
  const propiedad = array?.find(
    (resp: $TSMigrationFixMe) => resp?.key === QUERY_PARAMETERS?.FechaLowerLimit
  )
  const fechas = { FechaLowerLimit: "", FechaUpperLimit: "" }
  return propiedad?.query
    ?.split("&")
    ?.reduce((fechas: $TSMigrationFixMe, parte: $TSMigrationFixMe) => {
      const [nombre, fecha] = parte.split("=")
      fechas[nombre] = fecha
      return fechas
    }, fechas)
}

export const getImporteFilter = (array: $TSMigrationFixMe) => {
  const propiedad = array?.find(
    (resp: $TSMigrationFixMe) =>
      resp?.key === QUERY_PARAMETERS?.ImporteUpperLimit
  )
  const importes = { ImporteLowerLimit: "", ImporteUpperLimit: "" }
  return propiedad?.query
    ?.split("&")
    ?.reduce((importes: $TSMigrationFixMe, parte: $TSMigrationFixMe) => {
      const [nombre, importe] = parte.split("=")
      importes[nombre] = importe
      return importes
    }, importes)
}

export const getImporteAmortizacionFilter = (array: $TSMigrationFixMe) => {
  const propiedad = array?.find(
    (resp: $TSMigrationFixMe) =>
      resp?.key === QUERY_PARAMETERS?.ImporteAmortizacionUpperLimit
  )
  const importes = {
    ImporteAmortizacionLowerLimit: "",
    ImporteAmortizacionUpperLimit: "",
  }

  return propiedad?.query
    ?.split("&")
    ?.reduce((importes: $TSMigrationFixMe, parte: $TSMigrationFixMe) => {
      const [nombre, importe] = parte.split("=")
      importes[nombre] = importe
      return importes
    }, importes)
}

export const getRangedLabel = (
  start: $TSMigrationFixMe,
  end: $TSMigrationFixMe
) => {
  return [start, end].includes("Invalid date")
    ? ""
    : `${moment(start).format(DATE_DD_MM_YYYY)} - ${moment(end).format(
        DATE_DD_MM_YYYY
      )}`
}

// @ts-expect-error TS(7031): Binding element 'start' implicitly has an 'any' ty...
export const getRangedLabelComlet = ([start, end]) => {
  return [start, end].includes("Invalid date")
    ? ""
    : `${moment(start).format(DATE_DD_MM_YYYY)} - ${moment(end).format(
        DATE_DD_MM_YYYY
      )}`
}

export const getLabelFechasFilter = (array: $TSMigrationFixMe) => {
  if (!Array.isArray(array) || array.length === 0) {
    return ""
  }

  const queryStringObj = array.find(
    (resp) => resp?.key === QUERY_PARAMETERS?.FechaLowerLimit
  )

  if (!queryStringObj || !queryStringObj.query) {
    return ""
  }

  const queryString = queryStringObj.query

  const lowerLimitIndex = queryString.indexOf("FechaLowerLimit=")
  const upperLimitIndex = queryString.indexOf("FechaUpperLimit=")

  if (lowerLimitIndex === -1 || upperLimitIndex === -1) {
    return ""
  }

  const lowerLimit = queryString.substring(
    lowerLimitIndex + 16,
    lowerLimitIndex + 27
  )
  const upperLimit = queryString.substring(
    upperLimitIndex + 16,
    upperLimitIndex + 27
  )

  if (lowerLimit && upperLimit) {
    const lowerLimitDate = new Date(lowerLimit)
    const upperLimitDate = new Date(upperLimit)
    return `${moment(lowerLimitDate).format(DATE_DD_MM_YYYY)} - ${moment(
      upperLimitDate
    ).format(DATE_DD_MM_YYYY)}`
  }
  return ""
}

export const getValidDate = (
  selectedOptions: $TSMigrationFixMe,
  startDate: $TSMigrationFixMe,
  lastDate: $TSMigrationFixMe,
  dateFilterKeys: $TSMigrationFixMe
) => {
  const momentStartDate = selectedOptions
    ? moment(
        getLabelFechasFilter(selectedOptions).substring(0, 10),
        "DD_MM_YYYY"
      )
    : startDate

  const momentLastDate = selectedOptions
    ? moment(
        getLabelFechasFilter(selectedOptions).substring(13, 23),
        "DD_MM_YYYY"
      )
    : lastDate

  return {
    [dateFilterKeys[0]]: momentStartDate?.isValid()
      ? momentStartDate?.format(DATE_YYYY_MM_DD)
      : "",
    [dateFilterKeys[1]]: momentLastDate?.isValid()
      ? momentLastDate?.format(DATE_YYYY_MM_DD)
      : "",
  }
}
